<template>
  <div class="logoNavbar">
    <span>
      <svg
        width="103"
        height="15"
        viewBox="0 0 103 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.5 3.94052V0.505676H6.12018V3.94052H0.5Z" stroke="white" />
        <path d="M0.5 18.4962V6.75781H6.12018V18.4962H0.5Z" stroke="white" />
        <path
          d="M26.1335 9.46038V0.505676H31.5367V18.4962H26.4329L15.5627 8.05802L14.7163 7.24534V8.41866V18.4962H9.34149V0.505676H15.639L25.2862 9.82009L26.1335 10.6382V9.46038Z"
          stroke="white"
        />
        <path
          d="M34.7575 18.5V0.5H40.1588V9.72457V10.9721L41.0204 10.0699L50.1594 0.5H57.3929L40.1921 18.5H34.7575Z"
          stroke="white"
        />
        <path
          d="M45.1289 18.5L62.3298 0.5H67.7644V18.5H62.3631V9.27542V8.02788L61.5015 8.9301L52.3625 18.5H45.1289Z"
          stroke="white"
        />
        <path
          d="M87.7784 9.66231V0.505676H93.1816V18.4962H88.0786L77.2086 8.00047L76.3612 7.18234V8.36016V18.4962H70.9864V0.505676H77.2808L86.9273 10.0183L87.7784 10.8576V9.66231Z"
          stroke="white"
        />
        <path
          d="M96.4024 0.505676H102.023V12.2441H96.4024V0.505676Z"
          stroke="white"
        />
        <path
          d="M102.023 15.0633V18.4981H96.4024V15.0633H102.023Z"
          stroke="white"
        />
      </svg>
    </span>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  name: "Logo",
  mounted() {
    let allLetters = document.querySelectorAll(".logoNavbar span svg path");
    const tl = gsap.timeline({
      defaults: {
        ease: "none",
        duration: 0.3,
      },
      repeat: -1,
    });
    tl.to(allLetters, {
      fill: "#fff",
      stagger: 0.3,
    }).to(allLetters, {
      delay: 10,
      fill: "transparent",
      stagger: 0.3,
    });
  },
};
</script>
